module.exports = __webpack_public_path__ + "img/logo.04888f14.png";